import { useRouter } from 'next/router';
import { ReactElement, useMemo } from 'react';

interface AllowProps {
    children: ReactElement;
    allow: string[];
}

interface DisallowProps {
    children: ReactElement;
    disallow: string[];
}

type Props = AllowProps | DisallowProps;

const RouteRestrictedComponent = (props: Props) => {
    const { pathname } = useRouter();
    const allowed = useMemo(
        () => (props as AllowProps).allow?.includes(pathname),
        // TODO: fix this eslint-disable
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [(props as AllowProps).allow, pathname]
    );
    const notDisallowed = useMemo(
        () => (props as DisallowProps).disallow?.includes(pathname) === false,
        // TODO: fix this eslint-disable
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [(props as DisallowProps).disallow, pathname]
    );
    if (allowed || notDisallowed) {
        return <>{props.children}</>;
    } else {
        return <></>;
    }
};

export default RouteRestrictedComponent;
